export const cgmStatusOptions: any = [
  {
    value: "",
    label: "All",
  },
  {
    value: "NEW",
    label: "New",
  },
  {
    value: "EXPIRED",
    label: "Expired",
  },
  {
    value: "ACTIVE",
    label: "Active",
  },
];
